// useIdleLogout.ts
import { useEffect, useRef, useState } from "react";

export const useIdleLogout = (onLogout: () => void, timeout = 600000) => {
  const [isIdle, setIsIdle] = useState(false);
  const lastActivityRef = useRef<number>(Date.now());
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const resetTimer = () => {
    lastActivityRef.current = Date.now();
    setIsIdle(false);
  };

  useEffect(() => {
    const handleUserActivity = () => resetTimer();

    // Track all relevant user interactions
    window.addEventListener("mousemove", handleUserActivity);
    window.addEventListener("keydown", handleUserActivity);
    window.addEventListener("scroll", handleUserActivity);
    window.addEventListener("click", handleUserActivity);

    intervalRef.current = setInterval(() => {
      const elapsed = Date.now() - lastActivityRef.current;
      if (elapsed >= timeout && !isIdle) {
        setIsIdle(true);
        onLogout(); // ✅ Trigger the logout action
      }
    }, 1000);

    return () => {
      window.removeEventListener("mousemove", handleUserActivity);
      window.removeEventListener("keydown", handleUserActivity);
      window.removeEventListener("scroll", handleUserActivity);
      window.removeEventListener("click", handleUserActivity);
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [timeout, onLogout, isIdle]);
};
